import { IMillstoneDAIParams } from 'library/ts/interfaces/metadata/millstone/IMillstoneDAIParams';
import { IMillstoneMetadata } from 'library/ts/interfaces/metadata/millstone/IMillstoneMetadata';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @description Utility functions for Millstone
 */
export class MillstoneUtilities extends AbstractTagClass {

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				name: 'MillstoneUtilities',
				...argument
			}
		);
	}

	/**
	 * Returns millstone metadata from SmartTag params
	 * @param {IParamsVO} params
	 * @returns {IMillstoneMetadata}
	 */
	getMillstoneMetadata( params = this.tag?.params ): IMillstoneMetadata {
		return params?.CONTENT?.millstone;
	}

	/**
	 * Returns streamingUrl from millstone metadata
	 * @param {IParamsVO} params
	 * @returns {string}
	 */
	getStreamingUrl( params = this.tag?.params ): string {
		return this.getMillstoneMetadata( params )?.streamingUrl;
	}

	/**
	 * Returns DAI params from millstone metadata
	 * @param {IParamsVO} params
	 * @returns {IMillstoneDAIParams}
	 */
	getDaiParams( params = this.tag?.params ): IMillstoneDAIParams {
		return this.getMillstoneMetadata( params )?.daiParams;
	}

	/**
	 * Returns daiCmsId from DAI params within millstone metadata
	 * @param {IParamsVO} params
	 * @returns {string}
	 */
	getDaiCmsId( params = this.tag?.params ): string {
		return this.getDaiParams( params )?.daiCmsId;
	}
}